import React, {useState} from 'react'
import {gql, useMutation, useQuery} from '@apollo/client'
import {
  CREATE_LABEL,
  GET_LABELS,
} from '../../utils/api/campaign'
import {Button, Divider, Select, Tag, Tooltip} from 'antd'
import {PlusOutlined} from '@ant-design/icons'
import FormItem from '../forms/utils/FormItem'
import { Controller } from 'react-hook-form'

const CampaignLabelsManager = () => {
  const {data, loading} = useQuery(GET_LABELS, {
    variables: {perPage: 1000, page: 1},
  })
  const [newLabelName, setNewLabelName] = useState('')
  const [createLabel, {loading: creatingLabel}] = useMutation(CREATE_LABEL, {
    refetchQueries: ['LabelMany'],
    // update(cache, { data: { label } }) {
    //   cache.modify({
    //     fields: {
    //       labels: (existingLabels = []) => {
    //         console.log(label, existingLabels)
    //         const newLabelRef = cache.writeFragment({
    //           data: label,
    //           fragment: gql`
    //             fragment NewLabel on Label {
    //               _id
    //               name
    //             }
    //           `,
    //         })
    //         return [...existingLabels, newLabelRef]
    //       },
    //     },
    //   })
    // },
  })

  const [isDuplicate, setIsDuplicate] = useState(false)

  const handleCreateLabel = async (field) => {
    const {data} = await createLabel({
      variables: {
        record: {
          name: newLabelName,
        },
      },
    })
  
    // field.onChange([...(field.value || []), data.label._id])
  }

  if (loading) {
    return null
  }

  return (
    <FormItem label='Labels' top>
      <Controller
        name='labels'
        render={({ field }) => (
        <Select
          {...field}
          size='large'
          className="w-full sm:max-w-xs"
          placeholder='Add label'
          optionFilterProp='label'
          mode='multiple'
          maxTagCount={3}
          searchValue={newLabelName}
          onSearch={value => {
            setIsDuplicate(data.labels.items.some(({name}) => name === value))
            setNewLabelName(value)
          }}
          dropdownRender={(menu) => (
            <>
              {menu}
              <Divider className='my-2' />
                <Button
                  className='w-full'
                  loading={creatingLabel}
                  disabled={isDuplicate || !newLabelName}
                  icon={<PlusOutlined />}
                  onClick={() => handleCreateLabel(field)}
                >
                  Create new label
                </Button>
            </>
          )}
          options={data.labels.items.map((label: any) => ({
            label: label.name,
            value: label._id,
          }))}
          maxTagPlaceholder={(omittedValues) => (
            <Tooltip
              placement='right'
              title={omittedValues.map(({label}) => (
                <Tag className='my-1'>{label}</Tag>
              ))}
            >
              + {omittedValues.length}...
            </Tooltip>
          )}
        />
    )} />
    </FormItem>
  )
}

export default CampaignLabelsManager
